module.exports = __webpack_public_path__ + "assets/b9749b3a5642591e59b00216f9a6fac7.png";